import { memo } from 'react';

import { cn } from '@/shadcn/lib/utils';

import type { SetColumnFilter } from '@/components/ui/table/filters/filters.type';
import type { TableColumnTransformed } from '@/components/ui/table/table.type';
import { renderFilterComponent } from '../filters/filters';

type Props = {
  selectBoxWidth?: number;
  columns: TableColumnTransformed[];
  setColumnFilter: SetColumnFilter;
  invalidFilters?: boolean;
  disableClientSideSortFilter?: boolean;
};

export const TableFilters = memo(
  ({
    selectBoxWidth = 0,
    columns,
    setColumnFilter,
    invalidFilters = false,
    disableClientSideSortFilter = false
  }: Props) => (
    <div className="flex w-fit grow flex-row overflow-hidden border-border border-b bg-accent text-left text-[10px] text-muted-foreground">
      {selectBoxWidth > 0 && (
        <div
          style={{
            width: selectBoxWidth
          }}
        />
      )}
      {columns.map((colConfig, index) => {
        // retrieve the appropriate filter component
        const filterComponent = renderFilterComponent(
          colConfig,
          setColumnFilter,
          disableClientSideSortFilter
        );
        const isActive = filterComponent && colConfig.filter;
        return (
          <div
            className="relative px-1 py-2"
            key={`tableFilter_${index}`}
            style={{
              width: colConfig.width
            }}
          >
            {filterComponent}
            {isActive && (
              <div
                className={cn(
                  'absolute bottom-0 left-0 h-[3px] w-full bg-secondary',
                  invalidFilters && 'bg-destructive'
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  )
);
